import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

// Keep backend alive
setInterval(() => {
  API.get('/health').catch(() => {});
}, 4 * 60 * 1000);

// Automatically attach token to every request if user is logged in
API.interceptors.request.use((req) => {
  const user = localStorage.getItem('user');
  if (user) {
    req.headers.Authorization = `Bearer ${JSON.parse(user).token}`;
  }
  return req;
});

// ========== PRODUCTS ==========
export const getProducts = (params) => API.get('/products', { params });
export const getProduct = (id) => API.get(`/products/${id}`);
export const getBrands = () => API.get('/products/brands');
export const getSizes = () => API.get('/products/sizes');

// ========== NEW: Smart Search Metadata ==========
export const getCars = () => API.get('/products/meta/cars');
export const getModelsBycar = (car) => API.get(`/products/meta/cars/${car}`);
export const getYearsByCarModel = (car, model) => API.get(`/products/meta/cars/${car}/models/${model}`);

// ========== AUTH ==========
export const register = (data) => API.post('/auth/register', data);
export const login = (data) => API.post('/auth/login', data);
export const getProfile = () => API.get('/auth/profile');
export const updateProfile = (data) => API.put('/auth/profile', data);

// ========== CART ==========
export const getCart = () => API.get('/cart');
export const addToCart = (data) => API.post('/cart', data);
export const updateCart = (productId, data) => API.put(`/cart/${productId}`, data);
export const removeFromCart = (productId) => API.delete(`/cart/${productId}`);
export const clearCart = () => API.delete('/cart');

// ========== ORDERS ==========
export const placeOrder = (data) => API.post('/orders', data);
export const getMyOrders = () => API.get('/orders/my');
export const getOrder = (id) => API.get(`/orders/${id}`);

// ========== REVIEWS ==========
export const getReviews = (productId) => API.get(`/reviews/${productId}`);
export const addReview = (productId, data) => API.post(`/reviews/${productId}`, data);

// ========== ORDER REQUESTS ==========
export const submitOrderRequest = (data) => API.post('/order-requests', data);
export const getOrderRequests = (params) => API.get('/order-requests', { params });
export const updateOrderRequestStatus = (id, data) => API.put(`/order-requests/${id}/status`, data);

// ========== SERVICE BOOKINGS ==========
export const submitServiceBooking = (data) => API.post('/service-bookings', data);
export const getServiceBookings = (params) => API.get('/service-bookings', { params });
export const updateServiceBookingStatus = (id, data) => API.put(`/service-bookings/${id}/status`, data);

// ========== CONTACT MESSAGES ==========
export const submitContactMessage = (data) => API.post('/contact', data);
export const getContactMessages = () => API.get('/contact');
export const getMyMessages = () => API.get('/contact/my');
export const updateContactMessage = (id, data) => API.put(`/contact/${id}`, data);

// ========== MY ACCOUNT ==========
export const getMyOrderRequests = (params) => API.get('/order-requests/my', { params });
export const getMyServiceBookings = (params) => API.get('/service-bookings/my', { params });

// ========== UPLOAD ==========
export const uploadImage = (formData) => API.post('/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteImage = (publicId) => API.delete(`/upload/${publicId}`);

// ========== OTHER BRANDS ==========
export const getOtherBrands = () => API.get('/other-brands');
export const createOtherBrand = (data) => API.post('/other-brands', data);
export const updateOtherBrand = (id, data) => API.put(`/other-brands/${id}`, data);
export const deleteOtherBrand = (id) => API.delete(`/other-brands/${id}`);

export default API;